import $ from 'jquery';
import {cardRemove, getCardBalance} from '../../api/api';
import isViewport from '../../../scripts/util/window/isViewport';
import checkKey from '../../../scripts/util/event/checkKey';
import qs from '../../../scripts/util/dom/qs';
import addClass from '../../../scripts/util/dom/addClass';

import format from 'number-format.js';

export default class LoyaltyCard {
	constructor() {
		this.selectors = {
			el: '.js-loyalty-card',
			tmpl: '.js-loyalty-tmpl',
			remove: '.js-loyalty-remove',
			link: '.js-loyalty-link',
			balance: '.js-loyalty-balance',
			container: '.js-loyalty-card-container',
			message: {
				el: '.js-message',
				mob: '.js-message-mob',
				open: '.js-message-open',
				close: '.js-message-close',
				text: '.js-message-text',
				error: '.js-loyalty-error'
			}
		};

		this.states = {
			message: {
				open: 'message_state_visible',
				status: 'message_state_status',
				visible: 'my-loyalty__error-message_visible'
			},
			link: {
				hidden: 'loyalty-card__link_hidden'
			}
		};

		this.css = {
			'z-index': 20
		};

		this.mq = '(min-width: 768px) and (max-width: 1023px)';

		this.text = 'Вы уверены, что хотите отвязать карту?';

		this.$el = $(this.selectors.el);
		this.$document = $(document);
		this.$window = $(window);
	}

	getElements = () => {
		this.$remove = this.$el.find(this.selectors.remove);
		this.$message = this.$el.find(this.selectors.message.el);
		this.$messageMob = $(this.selectors.message.mob);
		this.$msgOpen = $(this.selectors.message.open);
		this.$msgClose = this.$message.find(this.selectors.message.close);
	}

	toggleMsgState = ($el, isClose = false) => {
		const openState = this.states.message.open;
		const $parent = $el.parent();
		if (isClose) {
			$el.addClass(openState);
			$parent.css(this.css);
		} else {
			$el.removeClass(openState);
			$parent.removeAttr('style');
		}
	}

	openMsg = e => {
		e.stopPropagation();
		const $target = $(e.currentTarget);
		const $card = $target.closest(this.selectors.el);
		const $msg = $card.find(this.selectors.message.el);
		this.$message.each((i, el) => this.toggleMsgState($(el)));
		this.toggleMsgState($msg, true);
	}

	closeMsg = e => {
		e.stopPropagation();
		const $target = $(e.currentTarget);
		const $msg = $target.closest(this.selectors.message.el);
		this.toggleMsgState($msg);
	}

	unbindCard = e => {
		const $target = $(e.target);
		const $card = $target.closest(this.selectors.el);
		const number = Number($card.children().data('number'));
		const cardData = {a: 'forget', card: number};
		cardRemove(cardData).then(
			data => this.setStatus($card, data),
			data => this.setStatus($card, data, true)
		);
	}

	removeCard = $el => {
		if ($el.length) {
			$el.remove();
		}
	}

	setStatus = ($card, data, fail = false) => {
		const $msg = $card.find(this.selectors.message.el);
		const $textEl = isViewport(this.mq) ? this.$messageMob.find(this.selectors.message.text) : $msg.find(this.selectors.message.text);
		const $link = $card.find(this.selectors.link);
		const $container = $card.closest(this.selectors.container);
		const latency = 1500;

		if (!isViewport(this.mq)) {
			$msg.addClass(this.states.message.status);
			setTimeout(() => {
				this.toggleMsgState($msg);
			}, latency);
		} else {
			this.toggleMsgState(this.$messageMob, true);
			this.toggleMsgState($msg);
			setTimeout(() => {
				this.toggleMsgState(this.$messageMob);
			}, latency);
		}

		if (!fail) {
			$link.addClass(this.states.link.hidden);
			setTimeout(() => {
				this.removeCard($card);
				$container.trigger('unbindCard');
			}, latency + 300);
		} else {
			setTimeout(() => {
				$msg.removeClass(this.states.message.status);
				$textEl.text(this.text);
			}, latency + 300);
		}

		this.setStatusText(data, $textEl);
	}

	setStatusText = (data, $textEl) => {
		const text = data.hasOwnProperty('message') ? data.message : 'Не удалось выполнить запрос';
		$textEl.html(text);
	}

	onKeyPress = e => {
		const $msg = this.$el.find(`.${this.states.message.open}`);
		if (checkKey(e) && $msg.length) {
			this.toggleMsgState($msg);
		}
	}

	showError = () => {
		const err = qs(this.selectors.message.error);
		addClass(this.states.message.visible, err);
	};

	showBalance = balace => data => {
		const response = JSON.parse(data);
		if (Number(response.status) === 0) {
			this.showError();
			return;
		}
		balace.text(format('# ##0.###', response.balance));
	}

	setBalance = (i, el) => {
		const $el = $(el);
		const $card = $el.children();
		const $balance = $card.find(this.selectors.balance);
		const number = Number($card.data('number'));
		const query = {a: 'balance', card: number};
		getCardBalance(query)
			.then(this.showBalance($balance))
			.catch(this.showError);
	};

	onLoad = () => {
		const $cards = $(this.selectors.el).not(this.selectors.tmpl);
		if ($cards.length) {
			$cards.each(this.setBalance);
		}
	};

	setHandlers = () => {
		this.$document.on('click', this.selectors.message.open, this.openMsg);
		this.$document.on('click', this.selectors.message.close, this.closeMsg);
		this.$document.on('click', this.selectors.remove, this.unbindCard);
		this.$document.on('keydown', this.onKeyPress);
		this.$window.on('load', this.onLoad);
	};

	render = () => {
		if (this.$el.length) {
			this.getElements();
			this.setHandlers();
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/my-loyalty/loyalty-card/index.js
 **/